import React from 'react'
import { Button } from 'hhsoig-design-system-core'

export const RetaliationReasonsWarning = () => {
  return (
    <div>
      <h2>You may not be a protected whistleblower</h2>
      <p>
        In order to be considered whistleblower retaliation, the retaliating
        party must have actual or constructive knowledge of a protected
        disclosure.
      </p>
      <Button
        variation="primary"
        data-testid="return-to-hhs-tips"
        href="https://oig.hhs.gov/fraud/report-fraud/index.asp"
      >
        Return to HHS-OIG Hotline
      </Button>
      <h4>If you wish to continue with your complaint</h4>
      <p>
        By selecting Acknowledge and continue, you acknowledge that you have
        read and understood that based on your selection, you may not be a
        protected whistleblower under HHS-OIG's jurisdiction.
      </p>
    </div>
  )
}
